module.exports = __webpack_public_path__ + "static/media/10.7ddc4f65.jpg";